// components/modals/ODModal.js

import React, { useState } from "react";
import "./LeaveModel.css";

export default function ODModal({ show, onClose, data, isManager, onAction }) {

    const [remark, setRemark] = useState("");

    if (!show || !data) return null;

    return (
        <div className="modal fade show d-block" style={{ background: "#00000080" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content shadow border-0 rounded-3">

                    {/* HEADER */}
                    <div className="modal-header bg-info text-white">
                        <h5 className="modal-title">On Duty (OD) Details</h5>
                        <button className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    {/* BODY */}
                    <div className="modal-body">

                        {/* ROW 1 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Leave Type</label>
                                <input className="form-control" value={data.leaveCode} readOnly />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">Total Days</label>
                                <input className="form-control" value={data.totalDays} readOnly />
                            </div>
                        </div>

                        {/* ROW 2 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">From Date</label>
                                <input
                                    className="form-control"
                                    value={new Date(data.fromDate).toLocaleDateString()}
                                    readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">To Date</label>
                                <input
                                    className="form-control"
                                    value={new Date(data.toDate).toLocaleDateString()}
                                    readOnly
                                />
                            </div>
                        </div>

                        {/* ROW 3 (TIME) */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Start Time</label>
                                <input
                                    className="form-control"
                                    value={data.startTime || "-"}
                                    readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">End Time</label>
                                <input
                                    className="form-control"
                                    value={data.endTime || "-"}
                                    readOnly
                                />
                            </div>
                        </div>

                        {/* ROW 4 */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Purpose / Reason</label>
                            <textarea
                                className="form-control"
                                value={data.reason || ""}
                                readOnly
                            />
                        </div>

                        {/* STATUS */}
                        {/* <div className="mb-3 text-center">
                            <span className={`badge px-3 py-2 ${
                                data.status === "Approved"
                                    ? "bg-success"
                                    : data.status === "Rejected"
                                        ? "bg-danger"
                                        : "bg-warning text-dark"
                            }`}>
                                {data.status}
                            </span>
                        </div> */}

                        {/* MANAGER ACTION */}
                        {isManager && data.status === "Pending" && (
                            <>
                                <hr />

                                <textarea
                                    className="form-control mb-2"
                                    placeholder="Enter remark"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                />

                                <div className="text-end">
                                    <button
                                        className="btn btn-success me-2"
                                        onClick={() => onAction(data.leaveAppID, "APPROVE", remark)}
                                    >
                                        Approve
                                    </button>

                                    <button
                                        className="btn btn-danger"
                                        onClick={() => onAction(data.leaveAppID, "REJECT", remark)}
                                    >
                                        Reject
                                    </button>
                                </div>
                            </>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
}